const Ga4 = (eventName, data, shippingMethod = '', paymentMethod = '') => {
    const quote = data.quote.quote;
    const itemData = quote.items.map((item) => {
        if (item.is_component) {
            return;
        }

        return {
            item_id: item.sku,
            item_name: item.product_name,
            affiliation: 'Customiser 2.0',
            discount: item.discount,
            item_brand: 'Sons',
            price: item.price,
            quantity: 1,
            item_variant: item.month_data
        }
    }).filter(function( element ) {
        return element !== undefined;
    });

    let coupon = '';
    if (typeof quote.discount_codes !== 'undefined'
        && quote.discount_codes !== '' && quote.discount_codes !== null) {
        try {
            const couponData = JSON.parse(quote.discount_codes);
            coupon = couponData[0].toUpperCase();
        } catch (e) {}
    }

    let ga4Data = {
        value: quote.grand_total,
        shipping: quote.shipping_total,
        currency: 'GBP',
        coupon: coupon,
        items: itemData
    };

    if (shippingMethod !== '') {
        ga4Data.shipping_tier = shippingMethod;
    } else if (paymentMethod !== '') {
        ga4Data.payment_type = paymentMethod;
    }

    if (typeof gtag !== 'undefined') {
        gtag('event', eventName, ga4Data);
    }
}

export default Ga4;